<template>
  <div class="card__wrapper">
    <div class="card" :class="{
      'card--list': appearance === 'list',
      'card--withdraw': transaction && transaction.type === 'withdraw',
    }">
      <template v-if="skeleton">
        <div class="card__index skeleton" style="border: none" />
        <h3 class="card__header skeleton" style="border: none; height: 30px; width: 100%;" />

        <div class="card__metadata">
          <p class="card__item">
            <span class="skeleton" style="height: 15px; width: 80px;" />
            <span class="skeleton" style="height: 15px; width: 140px;" />
          </p>

          <p class="card__item">
            <span class="skeleton" style="height: 15px; width: 80px;" />
            <span class="skeleton" style="height: 15px; width: 140px;" />
          </p>

          <p class="card__item" v-if="appearance === 'list'">
            <span class="skeleton" style="height: 15px; width: 80px;" />
            <span class="skeleton" style="height: 15px; width: 140px;" />
          </p>

          <p class="card__item" v-if="appearance === 'list'">
            <span class="skeleton" style="height: 15px; width: 80px;" />
            <span class="skeleton" style="height: 15px; width: 140px;" />
          </p>
        </div>
      </template>
      <template v-else>
        <div class="card__index">
          {{ index + 1 }}
        </div>

        <h3 class="card__header">
          Tranzacție
          <i class="fas fa-minus" v-if="transaction.type === 'withdraw'" />
          <i class="fas fa-plus" v-else />
        </h3>

        <div class="card__metadata">
          <p class="card__item">
            <span>Tip</span>
            <i class="fas fa-file-invoice-dollar" />
            <span>
              {{ transaction.type }}
            </span>
          </p>

          <p class="card__item">
            <span>Data</span>
            <i class="fas fa-calendar-alt" />
            <span>
              {{ transaction.created_at | moment('DD.MM.YYYY') }}
            </span>
          </p>

          <p class="card__item">
            <span>Suma</span>
            <span>
              <img src="@/assets/images/icons/coins.svg" v-if="appearance === 'list'" style="margin-left: 0; margin-right: 5px;">
              {{ transaction.credit }}
              <img src="@/assets/images/icons/coins.svg" v-if="appearance === 'grid'">
            </span>
          </p>

          <p class="card__item">
            <span>Descrierea</span>
            <i class="fas fa-info-circle" />
            <span v-if="transaction.type === 'payment' && transaction.details === null" style="text-transform: none">
              Fără informații
            </span>
            <a v-else-if="transaction.type === 'payment'" @click="$emit('openDetails', transaction)">
              Detalii...
            </a>
            <span v-else-if="transaction.type === 'tips'">
              {{ transaction.details }}
            </span>
            <span v-else-if="transaction.type === 'withdraw'">
              Plată efectuată
            </span>
          </p>
        </div>

        <i class="card__sign fas fa-minus" v-if="transaction.type === 'withdraw'"/>
        <i class="card__sign fas fa-plus" v-else />
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'appearance',
    'index',
    'skeleton',
    'transaction',
  ]
}
</script>

<style lang="scss" scoped>
.card__wrapper {
  padding: 10px;
}

.card {
  background: #ffffff;
  border: 1px solid transparent;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.06);
  padding: 20px;
  display: flex;
  flex-direction: column;
  height: initial !important;
  width: 100%;

  @include media-breakpoint-up(lg) {
    &--list {
      align-items: center;
      flex-direction: row;
      max-width: 100%;
      padding: 15px;
    }
  }

  &__index {
    align-items: center;
    border: 1px solid $color-primary;
    border-radius: 9999px;
    display: none;
    font-size: 16px;
    font-weight: 500;
    height: 35px;
    justify-content: center;
    text-align: center;
    width: 35px;
  }

  &--withdraw &__index {
    border-color: $color-warning;
  }

  @include media-breakpoint-up(lg) {
    &--list &__index {
      display: flex;
    }
  }

  &__header {
    border-bottom: 1px solid $color-primary;
    color: $color-gray;
    display: flex;
    font-size: 20px;
    font-weight: 500;
    justify-content: space-between;
    margin-bottom: 15px;
    padding-bottom: 5px;

    & > i.fas {
      color: $color-primary;
      font-size: 16px;
    }
  }

  @include media-breakpoint-up(lg) {
    &--list &__header {
      display: none;
    }
  }

  &--withdraw &__header {
    border-color: $color-warning;

    & > i.fas {
      color: $color-warning;
    }
  }

  &__metadata {
    display: flex;
    flex-direction: column;
  }

  @include media-breakpoint-up(lg) {
    &--list &__metadata {
      align-items: center;
      flex-direction: row;
      flex: 1;
      padding-left: 90px;
    }
  }

  &__item {
    align-items: center;
    color: $color-gray;
    display: flex;
    font-family: Roboto;
    font-size: 14px;
    font-weight: 400;
    justify-content: space-between;
    margin-bottom: 10px;

    &:last-child {
      margin-bottom: 0;
    }

    & > a,
    & > span:last-child {
      align-items: center;
      display: flex;
      font-weight: 500;
      text-transform: capitalize;

      & > img {
        margin-left: 5px;
      }
    }

    & > a {
      color: $color-primary;
      cursor: pointer;
    }

    & > i.fas {
      color: $color-primary;
      display: none;
      font-size: 17px;
      margin-right: 5px;
    }
  }

  @include media-breakpoint-up(lg) {
    &--list &__item {
      flex: 1;
      justify-content: initial;
      margin-bottom: 0;

      & > span:first-child {
        display: none;
      }

      & > i.fas {
        display: inline-block;
      }
    }

    &--withdraw &__item > i.fas {
      color: $color-warning;
    }
  }

  &__sign {
    color: $color-primary;
    display: none;
  }

  &--withdraw &__sign {
    color: $color-warning;
  }

  @include media-breakpoint-up(lg) {
    &--list &__sign {
      display: inline-block;
      font-size: 20px;
    }
  }

  /*

  &__info {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;

    &__item {
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
    }

    &__title,
    &__value {
      color: $color-gray;
      font-family: 'Roboto';
      font-size: 14px;
      font-weight: 400;
      line-height: 1;
      white-space: nowrap;
    }

    &__icon {
      color: $color-gray;
      display: none;
      font-size: 16px;
      margin-right: 10px;
    }

    &__value {
      font-weight: 500;
    }
  }



















  &--highlight {
    border-color: #00cd98;
  }

  &__specialist {
    align-items: center;
    display: flex;
    justify-content: space-between;
    margin-bottom: 30px;

    &__info {
      display: flex;
      flex-direction: column;
      justify-content: center;
      max-width: calc(100% - 80px);
    }

    &__name {
      color: $color-gray;
      font-size: 16px;
      font-weight: 500;
      line-height: 1;
      text-decoration: none;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      max-width: 100%;
      transition: 200ms color;

      &:not(div):hover {
        color: $color-primary;
      }
    }

    &__title {
      color: $color-secondary;
      font-size: 14px;
      font-weight: 400;
      line-height: 1;
      margin-top: 5px;
      white-space: nowrap;
    }

    &__avatar {
      border: 1px solid $color-light-gray;
      border-radius: 9999px;
      height: 60px;
      user-select: none;
      width: 60px;
      object-fit: cover;
    }
  }

  &--highlight &__specialist__avatar {
    border-color: #00cd98;
  }

  @include media-breakpoint-up(lg) {
    &--list &__specialist {
      justify-content: flex-start;
      margin-bottom: 0;
      margin-right: auto;
      padding-right: 30px;

      &__info {
        margin-left: 20px;
        order: 2;
      }

      &__avatar {
        order: 1;
      }
    }
  }

  &__info {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;

    &__item {
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
    }

    &__title,
    &__value {
      color: $color-gray;
      font-family: 'Roboto';
      font-size: 14px;
      font-weight: 400;
      line-height: 1;
      white-space: nowrap;
    }

    &__icon {
      color: $color-gray;
      display: none;
      font-size: 16px;
      margin-right: 10px;
    }

    &__value {
      font-weight: 500;
    }
  }

  @include media-breakpoint-up(lg) {
    &--list &__info {
      flex-direction: row;
      margin-bottom: 0;
      margin-right: 20px;

      &__item {
        align-items: center;
        margin-bottom: 0;
        margin-right: 30px;
      }

      &__title {
        display: none;
      }

      &__icon {
        display: block;
      }
    }
  }

  &__menu {
    display: flex;
    flex-direction: column;
  }

  &__action,
  &__subaction {
    background: transparent;
    border: 0;
    border-radius: 9999px;
    cursor: pointer;
    font-family: 'DIN Pro';
    font-size: 13px;
    line-height: 1;
    outline: none;
    padding: 10px 30px;
    text-align: center;
    white-space: nowrap;
    transition: 100ms opacity;
  }

  &__action {
    border: 1px solid transparent;
    font-weight: 500;

    &--gradient {
      background: $gradient-nexyo;
      border: none;
      color: #ffffff;

      &:hover {
        opacity: 0.8;
      }
    }

    &--primary {
      background: $color-primary;
      color: #ffffff;
      cursor: default !important;
    }

    &--secondary {
      background: #00cd98;
      color: #ffffff;

      &:hover {
        background: transparent;
        border-color: #00cd98;
        color: #00cd98;
      }
    }
  }

  &__subaction {
    font-weight: 400;

    &--danger {
      color: #fa0a26;
    }

    &--gray {
      color: rgba(55, 52, 53, 0.3);
      cursor: default !important;
    }

    &--secondary {
      color: $color-secondary;
      font-weight: 500;
    }
  }

  @include media-breakpoint-up(lg) {
    &--list &__menu {
      flex-direction: row;
      width: 350px;
    }

    &--list &__action {
      flex: 1;

      &--secondary {
        background: #00cd98;
        font-weight: 500;

        &:hover {
          background: transparent;
        }
      }
    }

    &--list &__subaction {
      margin-left: 20px;

      &--danger {
        background: #fa0a26;
        border: 1px solid transparent;
        color: #ffffff;

        &:hover {
          background: transparent;
          border-color: #fa0a26;
          color: #fa0a26;
        }
      }

      &--gray {
        display: none;
      }

      &--secondary {
        background: transparent;
        border: 1px solid #00cd98;
        color: #00cd98;
        font-weight: 500;

        &:hover {
          background: #00cd98;
          border-color: transparent;
          color: #ffffff;
        }
      }
    }
  }
  */
}
</style>
